import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AnexoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all Anexo
  list(params?: any): Observable<any[]> {
    return this.apiService
      .get<{ data: any[] }>(
        `${this.path}/getAllAnexo`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params
      )
      .pipe(map((response) => response.data));
  }

  // Create new Anexo
  public store(form: any): Observable<any> {
    const anexo = form;
    return this.apiService
      .post<{ object: any }>(`${this.path}/AddAnexo`, anexo)
      .pipe(map((response) => response.object));
  }

  // Update existing Anexo
  public update(form: FormGroup, id: string): Observable<any> {
    const anexo = form.value;
    return this.apiService
      .put<{ object: any }>(`${this.path}/UpdateAnexo/${id}`, anexo)
      .pipe(map((response) => response.object));
  }

  // Delete existing Anexo
  delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteAnexoById/${id}`);
  }

  // Get Anexo by ID
  public show(id: string): Observable<any> {
    return this.apiService
      .get<{ object: any }>(`${this.path}/getAnexoById/${id}`)
      .pipe(map((response) => response.object));
  }
}
